
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import './assets/styles/globals.css';
import { BrowserRouter } from 'react-router-dom';
// import LicenseGuard from './LicenseGuard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <LicenseGuard> */}
      <BrowserRouter>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    {/* </LicenseGuard> */}
  </React.StrictMode>
);